export const config = {
    namespaced: true,
    state: {
        sandbox: 0,
        // accessToken: '',
        // refreshToken: '',
        crm: 4,
        // discount: 100, // sleva Kc u placene prezentace
        discount: 0, // 11.5.2021 sleva bude 0, crm to neumelo pobrat :-)
        tax: 21,
        registration_email: 'registrace@ceskyinternet.cz',
    },
    mutations: {
        setSandbox(state, sandbox) {
            state.sandbox = sandbox
        },
        /*
        setAccessToken(state, accessToken) {
            state.accessToken = accessToken
        },
        setRefreshToken(state, refreshToken) {
            state.refreshToken = refreshToken
        },
        */
        setCrm(state, crm) {
            state.crm = crm
        },
    },
}
